import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";
import auth from "../../services/auth.js";
import security from "../../services/security.js";
import messaging from "../../services/messagingv2.js";

class PjheaderController {
  constructor(
    $http,
    $localStorage,
    $state,
    AuthService,
    SecurityService,
    TrackingService,
    $rootScope,
    $scope,
    $location,
    $timeout,
    $window,
    $companies,
    Messagingv2Service,
    ProfileService,
    EventsService,
    $interval
  ) {
    this.name = "pjheader";
    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$auth = AuthService;
    this.$rootScope = $rootScope;
    this.$security = SecurityService;
    this.$window = $window;
    this.$timeout = $timeout;
    this.$events = EventsService;
    this.$profile = ProfileService;
    this.$scope = $scope;
    this.showJobsDropDown = false;
    this.$tracking = TrackingService;
    this.$messagingv2 = Messagingv2Service;
    this.$companies = $companies;
    this.currentUser = this.$auth.getUserData();
    this.showPostScroll = false;
    this.showNoti = false;
    this.$location = $location;
    this.$interval = $interval;
    this.googleMapKey = this.$auth.$env.EnvironmentConfig.mapsKey;
    this.fullGoogleUrl = "https://maps.googleapis.com/maps/api/js?libraries=places&key=" + this.googleMapKey;

    var _this = this;

    $rootScope.$watch("$routeChangeStart", function () {
      _this.setActiveClass();
      if (!_this.$state.$current.url.sourcePath.includes("messages")) {
        _this.$rootScope.activeMessages = [];
        _this.$rootScope.activeChannel = undefined;
      }
    });

    if (!this.$rootScope.googleHasLoaded) {
      this.$rootScope.googleHasLoaded = true;
    }

    _this.showNotiListener = _this.$rootScope.$on("ShowNoti", function ($event, params) {
      _this.showNoti = true;
      _this.$timeout(function () {
        _this.showNoti = false;
      }, 2000);
    });

    _this.updateCurrentUserListener = _this.$rootScope.$on("UpdateCurrentUser", function (event, params) {
      _this.updateCurrentUser(params);
    });

    _this.autoSaveListener = _this.$rootScope.$on("AutoSave", function (event, params) {
      _this.showAuto = true;
      _this.autoSaveEventAsDraft(params);
    });

    _this.autoSaveListenerTrigger = _this.$rootScope.$on("AutoSaveTrigger", function (event, params) {
      if (params.pop === "on") {
        _this.showAuto = true;
      } else {
        _this.showAuto = false;
      }
    });

    _this.channelsHaveBeenLoadedListener = _this.$rootScope.$on("channelsHaveBeenLoaded", function ($event, params) {});

    _this.SetProfilePicturePajListener = _this.$rootScope.$on("SetProfilePicturePaj", function ($event, params) {
      console.log("SetProfilePictureListenerPaj");
      console.dir(params);
      console.dir(_this.currentUser);
      _this.currentUser.company.companyLogoUri = params.picture;
    });

    _this.ToastMessageListener = _this.$rootScope.$on("ToastMessage", function ($event, params) {
      _this.toastMessage(params);
    });

    this.JobSearchQueryParamsListener = _this.$rootScope.$on("JobSearchQueryParams", ($event, params) => {
      console.log("New params in header", params);

      const desktopInput = document.getElementById("location-search");
      const mobileInput = document.getElementById("mobile-location-search");

      if (params && params.zipcode && (params.zipcode !== this.zipCode || desktopInput.value === "" || desktopInput.value == params.zipcode)) {
        this.setZipCode(params.zipcode).then(() => {
          this.awaitForGoogleToLoad().then(() => {
            this.geocoder = new window.google.maps.Geocoder();

            this.geocoder.geocode({address: `${params.zipcode}`}, (results, status) => {
              if (status === "OK" && results && results.length) {
                const address = results[0].address_components;

                let city = "";
                let state = "";
                let county = "";

                address.forEach((a) => {
                  if (a.types.indexOf("locality") !== -1) {
                    city = a.long_name;
                  }
                  if (a.types.indexOf("country") !== -1) {
                    county = a.long_name;
                  }
                  if (a.types.indexOf("administrative_area_level_1") !== -1) {
                    state = a.short_name;
                  }
                });

                console.log("Syncing data in nav bar", city, state, county);

                desktopInput.value = `${city}, ${state}, USA`;
                mobileInput.value = `${city}, ${state}, USA`;
                this.setCityStateParams(city, state);
              }
            });
          });
        });
      }
      if (params && params.search) {
        this.setSearchTerm(params.search);
      }
    });

    _this.SetNewUserForJobBoardHeaderListener = _this.$rootScope.$on("SetNewUserForJobBoardHeader", function ($event, params) {
      _this.$timeout(function () {
        _this.currentUser = params.user;
        _this.$localStorage.logged_user = params.user;
      });
    });

    _this.SetApplyConfirmationListener = _this.$rootScope.$on("SetApplyConfirmation", function ($event, data) {
      _this.setApplicationStatus(data.params, data.user_not_verified);
    });

    _this.SignUserOutListener = _this.$rootScope.$on("SignUserOut", function (event, params) {
      _this.signOut();
    });

    _this.SetEventsToScrollerListener = _this.$rootScope.$on("SetEventsToScroller", function (event, params) {
      _this.setToDirective(params);
    });

    _this.GetLogoListener = _this.$rootScope.$on("GetLogo", function (event, params) {
      _this.get_logo(params);
    });

    _this.$scope.$on("$destroy", _this.GetLogoListener);
    _this.$scope.$on("$destroy", _this.SetEventsToScrollerListener);
    _this.$scope.$on("$destroy", _this.SetApplyConfirmationListener);
    _this.$scope.$on("$destroy", _this.SetNewUserForJobBoardHeaderListener);
    _this.$scope.$on("$destroy", _this.showNotiListener);
    _this.$scope.$on("$destroy", _this.autoSaveListener);
    _this.$scope.$on("$destroy", _this.autoSaveListenerTrigger);
    _this.$scope.$on("$destroy", _this.channelsHaveBeenLoadedListener);
    _this.$scope.$on("$destroy", _this.SetProfilePicturePajListener);
    _this.$scope.$on("$destroy", _this.ToastMessageListener);
    _this.$scope.$on("$destroy", _this.JobSearchQueryParamsListener);
    _this.$scope.$on("$destroy", _this.updateCurrentUserListener);
    _this.$scope.$on("$destroy", _this.SignUserOutListener);

    let cycle = (res, count, max) => {
      return new Promise((resolve, reject) => {
        this.$messagingv2.getChannelsv1(res.length).then(
          (response) => {
            if (response && response.data && response.data.length && count <= max) {
              cycle([...res, ...response.data], count + 1, max)
                .then((total) => {
                  console.log("TOTAL", total);
                  resolve(total);
                })
                .catch((err) => {
                  reject(err);
                });
            } else {
              console.error("NO MORE", count, max);
              resolve(res);
            }
          },
          (data) => {
            reject(data);
          }
        );
      });
    };

    if (!this.$security.isUndefinedOrNull(this.currentUser)) {
      if (this.currentUser.company && this.currentUser.company.id) {
        if (
          this.$security.isUndefinedOrNull(this.currentUser.company.companyLogoUri) &&
          this.$security.isUndefinedOrNull(this.$rootScope.companyLogoUri)
        ) {
          this.$rootScope.companyLogoUri = "/app/vendor/images/user-more.png";
          console.log("not here...11");
          this.get_logo(this.currentUser);
        } else {
          if (this.currentUser.company.companyLogoUri) {
            console.log("not here 2");
            this.$rootScope.companyLogoUri = this.currentUser.company.companyLogoUri;
            this.currentUser.companyProfilePictureUrl = this.currentUser.company.companyLogoUri;
            this.get_logo(this.currentUser);
          }
        }

        _this.isJobSeeker = false;
        _this.setTeamsToSession();
        _this.setJobbleTypesToSession();
      } else {
        this.checkAgreementStatus(this.currentUser);
        this.isJobSeeker = true;
        this.$rootScope.companyLogoUri = "/app/vendor/images/user-more.png";
      }
    } else {
      console.log("here...");
      this.$rootScope.channelsHaveLoaded = true;
      this.$rootScope.companyLogoUri = "/app/vendor/images/user-more.png";
      _this.initUnregisteredUser();
    }
  }

  setCityStateParams(city, state) {
    this.$location.search("loc", `${city},${state}`);
    this.$rootScope.$emit("CityStateSearch", {city, state});
  }

  toggleMobile() {
    this.showMobileModal = !this.showMobileModal;
    this.$timeout(() => {
      const mobileInput = document.getElementById("mobile-term");
      if (mobileInput) mobileInput.focus();
    }, 10);
  }

  $onInit() {
    this.$timeout(() => {
      this.zipCode = this.$localStorage.pb_zipCode;
      this.setZipCode(this.zipCode);
    });

    this.awaitForGoogleToLoad().then(() => {
      this.geocoder = new window.google.maps.Geocoder();

      const desktopInput = document.getElementById("location-search");

      const desktopAutocomplete = new google.maps.places.Autocomplete(desktopInput, {
        types: ["(cities)"],
        region: "US",
        componentRestrictions: {country: "us"},
      });

      google.maps.event.addListener(desktopAutocomplete, "place_changed", () => this.autoCompleteListener(desktopAutocomplete));

      const mobileInput = document.getElementById("mobile-location-search");

      const mobileAutocomplete = new google.maps.places.Autocomplete(mobileInput, {
        types: ["(cities)"],
        region: "US",
        componentRestrictions: {country: "us"},
      });

      google.maps.event.addListener(mobileAutocomplete, "place_changed", () => this.autoCompleteListener(mobileAutocomplete));
    });
  }

  autoCompleteListener(autocomplete) {
    console.time("zip code extraction");

    if (this.showMobileModal) {
      this.$timeout(() => {
        this.showMobileModal = false;
      });
    }

    var place = autocomplete.getPlace();

    const address = place.address_components;

    if (!address) return;

    let city = "";
    let state = "";
    let county = "";

    address.forEach((a) => {
      if (a.types.indexOf("locality") !== -1) {
        city = a.long_name;
      }
      if (a.types.indexOf("country") !== -1) {
        county = a.long_name;
      }
      if (a.types.indexOf("administrative_area_level_1") !== -1) {
        state = a.short_name;
      }
    });

    console.log("Setting new place", city, state, county);
    this.setCityStateParams(city, state);

    this.geocoder.geocode({address: `${city}, ${state}`}, (results, status) => {
      if (status === "OK") {
        var location = results[0].geometry.location;

        let coords = {
          lat: location.lat(),
          lng: location.lng(),
        };

        this.geocoder.geocode(
          {latLng: coords},
          (results, status) => {
            let zipCode = "";
            if (status === "OK") {
              if (results[0]) {
                for (var j = 0; j < results[0].address_components.length; j++) {
                  if (results[0].address_components[j].types[0] == "postal_code") {
                    zipCode = results[0].address_components[j].short_name;
                  }
                }
              }
              if ((!zipCode || zipCode === "") && results[1]) {
                for (var j = 0; j < results[1].address_components.length; j++) {
                  if (results[1].address_components[j].types[0] == "postal_code") {
                    zipCode = results[1].address_components[j].short_name;
                  }
                }
              }

              console.log("New Zip Code", zipCode);

              this.setZipCode(zipCode).then(() => {
                this.querySearch();
              });

              console.timeEnd("zip code extraction");
            } else {
            }
          },
          (error) => {}
        );
      } else {
        console.error(status);
      }
    });
  }

  awaitForGoogleToLoad() {
    let count = 0;
    return new Promise((resolve, reject) => {
      if (!angular.isUndefined(window.google)) return resolve();

      const id = Math.floor(Math.random() * 100000);
      this.goggleLoaders = this.goggleLoaders || {};
      this.goggleLoaders[id] = this.$interval(() => {
        count = count + 1;
        console.warn("Trying to load google", count);
        if (!angular.isUndefined(window.google) || count > 5) {
          resolve();
          this.$interval.cancel(this.goggleLoaders[id]);
          this.goggleLoaders[id] = undefined;
        }
      }, 500);
    });
  }

  setZipCode(zipCode) {
    return new Promise((resolve) => {
      this.$timeout(() => {
        this.zipCode = zipCode;
        this.$localStorage.pb_zipCode = zipCode;
        window.jobble_zip_code = zipCode;
        resolve();
      });
    });
  }

  submitOnEnter(e, mobile) {
    if (e.keyCode === 13) {
      this.querySearch();
      if (mobile) this.toggleMobile();
    }
  }

  setSearchTerm(search) {
    return new Promise((resolve) => {
      this.$timeout(() => {
        this.searchTerm = search;
        this.$localStorage.pb_searchTerm = search;
      });

      resolve();
    });
  }

  querySearch() {
    let search_data = {};

    const input = document.getElementById("location-search");
    const mobileInput = document.getElementById("mobile-location-search");

    const zipCodePattern = /^\d{5}$|^\d{5}-\d{4}$/;

    if (input.value && zipCodePattern.test(input.value)) {
      this.zipCode = input.value;
    }

    if (mobileInput.value && zipCodePattern.test(mobileInput.value)) {
      this.zipCode = mobileInput.value;
    }

    search_data.zip_code = this.zipCode;
    search_data.type = "text_search";
    search_data.value = this.searchTerm;

    console.log("search data");
    console.dir(search_data);

    let tracking_data = {};
    tracking_data.type = "Job";

    this.currentUser = this.$auth.getUserData();

    if (this.currentUser) {
      tracking_data.user = this.currentUser.email;
    } else {
      tracking_data.user = "Not Logged In";
    }

    const currentpath = window.location.pathname || "";

    this.$localStorage.pb_searchTerm = this.searchTerm;
    this.$localStorage.pb_zipCode = this.zipCode;

    if (currentpath.indexOf("jobs") !== -1) {
      const parcel = {
        zipcode: search_data.zip_code,
        type: search_data.type,
        query: search_data.value,
      };
      this.$rootScope.$emit("SendSearchParcel", parcel);
      this.$tracking.reportSubmitSearch("job board", search_data.value, search_data.zip_code);
    } else {
      this.$location.path("/jobs").search({
        t: search_data.type,
        z: search_data.zip_code,
        q: search_data.value,
      });
      this.$tracking.reportSubmitSearch("general", search_data.value, search_data.zip_code);
    }

    console.log("currentstate", this.$state.current.name);

    if (this.$state.current.name === "jobdetails") {
      tracking_data.page = "Job Details";
      this.$tracking.reportJobSearch(tracking_data);
    } else {
      this.$timeout(() => {
        tracking_data.page = "Job Listings";
        this.$tracking.reportJobSearch(tracking_data);
      });
    }
  }

  slideToggle() {
    var _this = this;
    if (_this.isJobSeeker) {
      _this.$timeout(function () {
        $(".mobile-menu-wrap").show();
      });
    } else {
      _this.$timeout(function () {
        $(".mobile-menu-wrap").show();
      });
    }
  }

  closeSideBar() {
    var _this = this;
    _this.$timeout(function () {
      $(".mobile-menu-wrap").hide();
    });
  }

  get_logo(user) {
    var _this = this;

    console.log("get_logo 2");
    console.dir(_this.currentUser);

    if (_this.currentUser) {
      _this.updateCurrentUser();
    }
    _this.$auth.grab_company_logo(user.access_token).then(
      function (response) {
        console.log("logo resposne");
        console.dir(response);
        let logo = response.data.company.companyLogoUri;
        _this.set_logo_to_header(logo);
        _this.$timeout(function () {
          _this.$rootScope.$emit("SetLogoToEventsPage", logo);
        });
      },
      function (error) {
        console.log("grabbing logo error");
        console.dir(error);
      }
    );
  }

  set_logo_to_header(logo) {
    var _this = this;
    _this.$timeout(function () {
      if (_this.currentUser) {
        _this.currentUser.company.companyLogoUri = logo;
        _this.$rootScope.companyLogoUri = logo;
        _this.currentUser.companyProfilePictureUrl = logo;
      }
    }, 300);
  }

  updateCurrentUser(params) {
    var _this = this;
    if (params) {
      _this.$timeout(function () {
        _this.currentUser = params.user;
        _this.$localStorage.logged_user = params.user;
        if (_this.$rootScope.channels) {
          _this.$rootScope.channelsHaveLoaded = true;
        }
        if (_this.currentUser.company && _this.currentUser.company.id) {
          _this.isJobSeeker = false;
        } else {
          _this.isJobSeeker = true;
        }
      }, 300);
    }
  }

  signOut(manager) {
    var _this = this;
    this.$auth.signOut().then(function (response) {
      _this.$timeout(function () {
        _this.$tracking.reportUserLogout(_this.$localStorage.logged_user);
        _this.$localStorage.logged_user = undefined;
        _this.$rootScope.channels = undefined;
        _this.$rootScope.companyLogoUri = undefined;
        _this.$rootScope.inboxLink = undefined;
        _this.$rootScope.channelsHaveLoaded = undefined;
        _this.$rootScope.teams = undefined;
        _this.$rootScope.teamsSimple = undefined;
        _this.$rootScope.globalParams = undefined;
        _this.$rootScope.imgFromProfilePage = undefined;
        _this.$rootScope.jobbleTypes = undefined;
        _this.$rootScope.jobs = undefined;
        _this.$rootScope.jobsSeenOnce = undefined;
        _this.$rootScope.boardParameters = null;
        _this.$messagingv2.setHandleLastMessageDataCounter(0);
        _this.$messagingv2.setTotalAmountOfMissedMessages(0);

        _this.$timeout(() => {
          console.log("LOCAL");
          console.dir(JSON.stringify(localStorage, null, 4));
          _this.$location.path(manager ? "/signin" : "/signin");
        }, 20);
      });
    });
  }

  goToSomeChat(event) {
    var _this = this;
    var missedMessagesFound = false;
    var channelToGoToInURL = undefined;
    try {
      for (var i = 0; i < event.channelArrayHolder.length; i++) {
        if (event.channelArrayHolder[i].missedMessagesCount > 0) {
          missedMessagesFound = true;
          channelToGoToInURL = event.channelArrayHolder[i].name;
          break;
        }
      }
    } finally {
      if (missedMessagesFound) {
        this.$location.path("/messages/event/" + event.eventId).search({c: channelToGoToInURL});
      } else {
        this.$location.path("/messages/event/" + event.eventId);
      }
    }
  }

  inboxLink() {
    var _this = this;
    if (_this.$rootScope.channelsHaveLoaded && !_this.$rootScope.channels) {
      alert("This account has no active messages. If you think there are active messages please refresh the page.");
    } else {
      _this.$timeout(function () {
        _this.$state.go("inbox");
      });
    }
  }

  toastMessage(params) {
    var _this = this;
    var msg = params.m.messagePayload.message;
    if (msg.length > 75) {
      msg = msg.substring(0, 99);
      msg = msg + " ...";
    }
    _this.notMsg = msg;
    _this.notUser = params.m.messagePayload.username;
    _this.notImage = params.m.messagePayload.userProfileImage;
    _this.notChan = params.channel;
    _this.notEventId = params.m.messagePayload.eventId;
    _this.$timeout(function () {
      jQuery("#notification-tab").show("fast");
    });
  }

  closeNotification(eventId, channel) {
    var _this = this;
    _this.$timeout(function () {
      jQuery("#notification-tab").hide("fast");
    });
  }

  goToChat(eventId, channel) {
    var _this = this;
    if (eventId) {
      _this.$location.path("/messages/event/" + eventId).search({c: channel});
    } else {
      return;
    }
  }

  setJobbleTypesToSession() {
    var _this = this;
    if (!_this.$rootScope.jobble_types) {
      _this.loadJobbleTypes();
    }
  }

  loadJobbleTypes() {
    var _this = this;
    console.log("loadJobbleTypes 2");
    _this.$auth.getJobbleTypes().then(
      function (data) {
        _this.$rootScope.jobble_types = data.data;
        _this.$timeout(function () {
          _this.$rootScope.$emit("SetJobbleTypes", {
            jobbleTypes: data.data,
          });
        });
      },
      function (data) {
        _this.jobbleTypes = [];
        _this.$timeout(function () {
          jQuery("#show-application-alert").trigger("click");
        }, 100);
      }
    );
  }

  setTeamsToSession() {
    var _this = this;
  }

  loadTeams() {
    var _this = this;
    var teamsSimple = [];
    var teams = [];
    _this.$companies.getTeamsTrim().then(
      function (data) {
        try {
          data.data.forEach(function (team, index) {
            _this.setAvatarImageToUsersOfTeam(team);
            team.firstLoadUsersCount = Math.min(team.users.length, 6);
            if (team.firstLoadUsersCount == 6) {
              team.firstLoadUsersCount = 5;
            }

            teams.push(team);
            var teamsObj = {};
            teamsObj.name = team.name;
            teamsObj.id = team.id;
            teamsSimple.push(teamsObj);
          });
        } finally {
          _this.$timeout(function () {
            _this.$rootScope.teams = teams;
            _this.$rootScope.teamsSimple = teamsSimple;
            _this.$rootScope.$emit("TeamsHaveLoaded", {
              teams: teams,
            });
          });
        }
      },
      function (data) {
        _this.$rootScope.teams = [];
        _this.$timeout(function () {
          jQuery("#show-application-alert").trigger("click");
        }, 100);
      }
    );
  }

  setAvatarImageToUsersOfTeam(team) {
    var _this = this;
    if (team.users) {
      team.users.forEach(function (userProfile) {
        if (!_this.$security.isUndefinedOrNull(userProfile.picture1s)) {
          userProfile.picture1s.forEach(function (pic) {
            if (pic.indexOf("75x75") > -1) {
              userProfile.pictureAvatarUrl = pic;
            }
            if (pic.indexOf("160x160") > -1) {
              userProfile.pictureAvatarUrlBig = pic;
            }
          });
        }

        if (_this.$security.isUndefinedOrNull(userProfile.pictureAvatarUrl)) {
          userProfile.pictureAvatarUrl = userProfile.pictureAvatarUrlBig;
        }

        if (_this.$security.isUndefinedOrNull(userProfile.pictureAvatarUrl)) {
          userProfile.pictureAvatarUrl = "/app/vendor/images/defaultimg.jpeg";
        }
      });
    }
  }

  closeNoti(x) {
    var _this = this;
    _this.showNoti = false;
    if (x === 2) {
      _this.$timeout(function () {
        jQuery(".modal-backdrop").remove();
        jQuery("body").removeClass("modal-open");
      });
    }
  }

  closeAutoSave(x) {
    var _this = this;
    _this.showAuto = false;
  }

  autoSaveEventAsDraft(params) {
    var _this = this;
    if (params.update) {
      _this.$timeout(function () {
        _this.showAuto = false;
      }, 2000);
    } else {
      if (!params.questions) {
        params.questions = [];
        var p = {
          question: "Are you a good fit?",
          questionType: 1,
          name: "Question 1",
        };
        params.questions.push(p);
      }
      _this.$events.saveDraft(params).then(
        function (response) {
          if (response.data.status === "error") {
            _this.$timeout(function () {
              _this.showAuto = false;
            });
            if (response.data.message.indexOf("Data too long for column 'dress_code'") > -1) {
              alert("The Dress Code on page 1 is too long. Please go back and shorten.");
            } else {
              alert("There was an issue please contact an admin.");
            }
            return;
          }
          _this.$timeout(function () {
            _this.showAuto = false;
            _this.$rootScope.$emit("SetEventIdForDrafting", {
              draftData: response,
            });
          }, 2000);
        },
        function (error) {
          console.log("we are in error");
          console.dir(error);
        }
      );
    }
  }

  logOnboardingTracking(event) {
    var _this = this;
    _this.$tracking.reportOboardingScreenOne(event);
  }

  setActiveClass() {
    var _this = this;
    if (_this.$state.current.url.indexOf("/events") > -1) {
      _this.$timeout(function () {
        jQuery(".pull-right ul li:nth-child(2)").addClass("active");
      });
    }
    if (_this.$state.current.url.indexOf("/transactionhistory") > -1) {
      _this.$timeout(function () {
        jQuery(".pull-right ul li:nth-child(3)").addClass("active");
      });
    }
    if (_this.$state.current.url.indexOf("/teams") > -1) {
      _this.$timeout(function () {
        jQuery(".pull-right ul li:nth-child(4)").addClass("active");
      });
    }
    if (_this.$state.current.url.indexOf("/inbox") > -1) {
      _this.$timeout(function () {
        jQuery(".pull-right ul li:nth-child(5)").addClass("active");
      });
    }
  }

  initUnregisteredUser() {
    var _this = this;
    _this.isJobSeeker = true;
  }

  funnelToMobileApp(x) {
    var _this = this;
    let button = null;
    switch (x) {
      case 1:
        _this.text = "hi";
        button = "Applications";
        break;
      case 2:
        _this.text = "hi";
        button = "Messages";
        break;
      case 3:
        _this.text = "hi";
        button = "Jobs";
        break;
      case 4:
        _this.text = "hi";
        button = "Payments";
        break;
    }
    _this.trackingHeader(button);
  }

  moreInfoModal() {
    var _this = this;
    if (_this.appError) {
      _this.$timeout(function () {
        $(".noti-message-application-error").hide("fast");
      });
    } else {
      _this.$timeout(function () {
        $(".noti-message-application-success").hide("fast");
      });
    }
    _this.$timeout(function () {
      $("#more-application-info").modal();
    }, 500);
  }

  setApplicationStatus(data, user_not_verified) {
    var _this = this;
    if (data.data.status === "error") {
      if (data.data.message === "Applicant already applied for jobble in the pool") {
        _this.applicationText = "You already applied to this job. Please pick another.";
      } else {
        _this.applicationText = "There was an issue with your application. Please try again later.";
      }
      _this.appError = true;
    } else {
      _this.applicationText = "Success! Check your application status on our mobile app.";
      _this.appError = false;
    }
    if (user_not_verified) {
      _this.$timeout(function () {
        $("#finishing-steps").modal();
      }, 300);
    }
    _this.$timeout(function () {
      _this.applicationText = null;
    }, 10000);
  }

  closeNotiApp() {
    var _this = this;
    _this.applicationText = null;
  }

  trackingHeader(button) {
    var _this = this;
    let data = {};
    if (!_this.currentUser) {
      data.username = "Unregistered";
    } else {
      data.username = _this.currentUser.username;
    }
    data.button = button;
    _this.$tracking.reportHeaderClicks(button);
  }

  goToProfile() {
    var _this = this;
  }

  goToEvents() {
    var _this = this;
    _this.$state.go("events");
  }

  showPostBlur() {
    var _this = this;
    _this.$timeout(function () {
      $(".hidden-drop-down-post-types").hide("slide", {direction: "up"}, 100);
      _this.showPostScroll = false;
    }, 300);
  }

  validateEvent() {
    const shiftsValids = this.validateShifts();
    return {disabled: !shiftsValids || !this.event.contactInfo};
  }

  validateShifts() {
    let allValid = true;

    if (!this.event || !this.event.shifts || !this.event.shifts.length) {
      allValid = false;
      return allValid;
    }

    this.event.shifts.forEach((shift) => {
      const valid = this.$events.validateWorflowShift(shift);
      if (!valid) allValid = false;

      return valid;
    });

    if (allValid) {
      if (!this.$events.validateWorflowShiftsNonOverlapping(this.event.shifts)) {
        allValid = false;
      }
    }

    return allValid;
  }

  saveAndExit() {
    console.log("saveAndExit");
    this.$timeout(() => {
      this.$rootScope.$emit("PostAJobSaveAndExit", {});
      this.$rootScope.$emit("channelsHaveBeenLoaded", {});
      this.$state.go("jobsdashboard");
    });
  }

  showJobScroll() {
    var _this = this;
    let showList = null;
    console.log("_this.$localStorage.events");
    console.dir(_this.$localStorage.events);

    if (_this.showJobsDropDown === false) {
      _this.$timeout(function () {
        _this.$rootScope.$emit("ListEventsForScroll", {});
        _this.showJobsDropDown = true;
        $(".hidden-drop-down").show("slide", {direction: "up"}, 100);
      });
    } else {
      _this.$timeout(function () {
        _this.showJobsDropDown = false;
        $(".hidden-drop-down").hide("slide", {direction: "up"}, 100);
      });
    }
  }

  showDropDownList() {
    var _this = this;
    _this.$timeout(function () {
      _this.$rootScope.$emit("ListEventsForScroll", {});
      $(".hidden-drop-down").show("fast");
    });
    _this.showJobsDropDown = true;
  }

  setToDirective(params) {
    var _this = this;
    _this.$timeout(function () {
      _this.$rootScope.$emit("SetEventsToJobsScroll", {params});
    });
  }

  jobDropDownBlur() {
    var _this = this;
    _this.$timeout(function () {
      $(".hidden-drop-down").hide("slide", {direction: "up"}, 100);
      _this.showJobsDropDown = false;
    }, 300);
  }

  jobDropDownFocus() {
    var _this = this;
  }

  jobDropDownHover() {
    var _this = this;
    _this.showJobScroll();
  }

  jobDropDownLeave() {
    var _this = this;
    _this.showJobScroll();
  }

  reportHeaderDropDownClick(link) {
    var _this = this;
    let data = {};
    if (_this.currentUser) {
      data.user = _this.currentUser.email;
    } else {
      data.user = "Unregistered";
    }
    switch (link) {
      case 1:
        data.button = "Account";
        return;
      case 2:
        data.button = "Direct Pay";
        return;
      case 3:
        data.button = "Help Center";
        return;
      case 4:
        data.button = "Logout";
        return;
    }
    _this.$tracking.reportHeaderMenuInteraction(data);
  }

  go_to_bulk_upload_jobs_page() {
    this.$state.go("postjobbulk");
  }

  send_to_basic_profile() {
    var _this = this;
    _this.$timeout(function () {
      $("#finishing-steps").modal("toggle");
    });
    _this.$timeout(function () {
      _this.$state.go("jobbler", {});
    }, 300);
  }

  checkAccountType() {
    var _this = this;
    let cid = _this.currentUser.company.id;
    if (cid) {
      if (_this.currentUser.company.industryType) {
        let industry_type_id = _this.currentUser.company.industryType.id;
        if (industry_type_id) {
          _this.currentUser.company.industry = "Delivery";
        } else {
          console.log("we do not have an industry type");
        }
      }
    }
  }

  rotate() {
    var _this = this;
    _this.$timeout(function () {
      $(".main-menu ul li a i").toggleClass("down");
    });
  }

  checkAgreementStatus(user) {
    console.log("checkAgreementStatus");
    console.dir(user);

    if (user.acceptedCookiePolicy === null || user.acceptedPrivacyPolicy === null) {
      this.$timeout(() => {
        $("#agree-to-terms").modal({
          backdrop: "static",
          keyboard: false,
        });
      });
    } else if (user.acceptedCookiePolicy === null) {
      this.$timeout(() => {
        $("#agree-to-terms").modal({
          backdrop: "static",
          keyboard: false,
        });
      });
    }

    /*

  	  */

    /*
  	  this.$profile.saveUser(payload).then(function(){

  	  }.);
  	  */

    /*
  	  this.$timeout(() => {
  		  $("#agree-to-terms").modal({backdrop: 'static', keyboard: false});
  	  });
  	  */
  }

  setLoader() {
    this.$timeout(() => {
      $("html").addClass("wait");
    });
  }

  unSetLoader() {
    this.$timeout(() => {
      $("html").removeClass("wait");
    });
  }

  userAcceptsTOS(result, closeForm) {
    var _this = this;

    _this.setLoader();

    let payload = {};

    //payload.acceptedWebAgreement = result;
    //payload.acceptedMobileAgreement = result;

    console.log("what is result");
    console.dir(result);

    payload.acceptedPrivacyPolicy = result;
    payload.acceptedCookiePolicy = result;

    console.log("saving user...");
    console.dir(payload);

    _this.$profile.saveUser(payload).then(
      (response) => {
        _this.unSetLoader();

        console.log("what is response.");
        console.dir(response);
        console.dir(closeForm);
        console.dir(result);

        if (closeForm) {
          if (result === false) {
            _this.$timeout(() => {
              $("#opt-out").modal("toggle");
            });
          } else {
            _this.$timeout(() => {
              $("#opt-in").modal("toggle");
            });
          }

          _this.$timeout(function () {
            _this.$rootScope.$emit("UpdatePrefenceUI", result);
          });
        } else {
          _this.$timeout(() => {
            $("#agree-to-terms").modal("toggle");
          });
        }

        _this.currentUser = _this.$auth.reloadCurrentUser();

        console.log("_this.currentUser now");
        console.dir(_this.currentUser);
      },
      (error) => {
        this.unSetLoader();

        if (closeForm) {
          if (result === false) {
            _this.$timeout(() => {
              $("#opt-out").modal("toggle");
            });
          } else {
            _this.$timeout(() => {
              $("#out-in").modal("toggle");
            });
          }
        } else {
          _this.$timeout(() => {
            $("#agree-to-terms").modal("toggle");
          });
        }
      }
    );
  }

  userDeclinesTOS() {
    console.log("userDeclinesTOS");
  }

  validateTOS() {
    var _this = this;

    let result = false;

    console.log("validateTOS");
    console.dir(_this.currentUser.email);
    console.dir(_this.tosEmail);

    if (_this.currentUser.email === _this.tosEmail) {
      result = true;
    }

    return result;
  }

  optOut() {
    var _this = this;

    let validate = _this.validateTOS();

    if (validate) {
      _this.userAcceptsTOS(false, true);
    } else {
      alert("Please provide your correct email.");
    }
  }

  optIn() {
    var _this = this;

    let validate = _this.validateTOS();

    if (validate) {
      _this.userAcceptsTOS(true, true);
    } else {
      alert("Please provide your correct email.");
    }
  }
}

PjheaderController.$inject = [
  "$http",
  "$localStorage",
  "$state",
  "auth",
  "security",
  "tracking",
  "$rootScope",
  "$scope",
  "$location",
  "$timeout",
  "$window",
  "companies",
  "messagingv2",
  "profile",
  "events",
  "$interval",
];

export default PjheaderController;



// WEBPACK FOOTER //
// ./client/app/common/pjheader/pjheader.controller.js